import React, { Component, useRef, useCallback } from 'react';
import moment from 'moment';
import {
    format, startOfMonth, endOfMonth, differenceInCalendarDays, addDays, getMonth, getYear,
    endOfToday, startOfToday, isBefore, isAfter, isSameDay, isMonday, isTuesday, isWednesday, isThursday,
    isFriday, isSaturday, isSunday
} from 'date-fns';
import commonFunction from '../../../../lib/utils/common';
// import styles from "./calendar.module.css";

const MonthList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const weekList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

class MobileCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dateFormat: !commonFunction.isValueEmpty(this.props.dateFormat) ? this.props.dateFormat : "dd/MM/yyyy",
            isCalendarVisible: false,
            numberOfClicks: 0,
            twoCalendarsArray: [],
            isDoubleSelection: !commonFunction.isValueEmpty(this.props.doubleSelection) ? this.props.doubleSelection : false,
            dateLimitArr: this.props.startDateLimit,
            currentMonths: [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: startOfMonth(startOfToday()),
            selectedMonthEndDate: endOfMonth(startOfMonth(new Date())),
            endDate: this.props.endDate,
            hoverEndDate: this.props.endDate,
            totalDays: "",
            totalNights: '',
            pageX: "",
            pageY: "",
            initPageX: "",
            initPageY: "",
            totalMonths: !commonFunction.isValueEmpty(this.props.totalMonths) ? this.props.totalMonths : 12,
            serviceType: this.props.serviceType ? this.props.serviceType : ""
        };
        this.debouncedOnClickDateCell = this.debounce(this.onClickDateCell,1);
    }

    componentDidMount() {
        this.setState({
            currentMonths: this.props.type === "double" ? !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))),
                getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd')))) + 1] :
                [getMonth(startOfMonth(new Date())), getMonth(startOfMonth(new Date())) + 1] : !commonFunction.isValueEmpty(this.state.dateLimitArr) ?
                [getMonth(startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))))] :
                [getMonth(startOfMonth(new Date()))],
            selectedMonthStartDate: !commonFunction.isValueEmpty(this.state.dateLimitArr) ? startOfMonth(new Date(this.specDateEle(this.state.dateLimitArr, 'y'), this.specDateEle(this.state.dateLimitArr, 'm'), this.specDateEle(this.state.dateLimitArr, 'd'))) : startOfMonth(startOfToday()),
        })
    }
    componentDidUpdate() {
        if (this.props.endDate !== this.state.endDate) {
            this.setState({ endDate: this.props.endDate });
        }
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside = () => {
        if (this.state.isCalendarVisible === true) this.setState({ isCalendarVisible: false });
    };

    debounce(func, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(this, args), wait);
        };
    }

    specDateEle(date, type) {
        try {
            let toDefaultFormat = moment(date, this.state.dateFormat);
            let getDate = toDefaultFormat.format(this.state.dateFormat);
            let getYear = typeof date === 'string' ? new Date(getDate).getFullYear() : date.getFullYear();
            let getMonth = typeof date === 'string' ? new Date(getDate).getMonth() : date.getMonth();
            let getDay = typeof date === 'string' ? new Date(getDate).getDate() : date.getDate();
            switch (type) {
                case 'y':
                    return getYear;
                case 'm':
                    return getMonth;
                case 'd':
                    return getDay;
                case 'a':
                    return [getYear, getMonth, getDay];
                default:
                    return null;
            }
        } catch (err) {
            console.log('Error in specDateEle:', err);
            return null;
        }
    }

    onClickChangeVisibility = () => {
        this.props.changeVisibility(!this.props.isVisible);
    }

    onClickDateCell = (day, month, year, bool) => {
        if (!bool) {
            if (this.state.isDoubleSelection === true) {
                let date = new Date(year, month, day);
                if (this.state.numberOfClicks === 0) {
                    let differenceInDays = differenceInCalendarDays(new Date(addDays(new Date(date), 1)), new Date(date));
                    this.setState({ numberOfClicks: 1, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                        this.props.onChangeDate(date, 'startDate');
                        this.props.onChangeDate(addDays(new Date(date), 1), 'endDate');
                    });
                } else if (this.state.numberOfClicks === 1) {
                    let differenceInDays = differenceInCalendarDays(new Date(date), new Date(this.props.startDate));
                    if (differenceInDays < 0) {
                        this.setState({ numberOfClicks: 0, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                            this.props.onChangeDate(date, 'startDate');
                            this.props.onChangeDate(addDays(new Date(date), 1), 'endDate');
                        });
                    } else {
                        this.setState({ numberOfClicks: 0, totalNights: differenceInDays > 0 ? differenceInDays : '' }, () => {
                            this.props.onChangeDate(date, 'endDate');
                        });
                    }
                }
            } else {
                let date = moment(new Date(year, month, day)).format(this.state.dateFormat);
                this.props.onChangeDate(date);
            }
        }
    }

    renderCalendar = () => {
        let temp = this.state.selectedMonthStartDate;
        let twoCalendarsArray = [];
        for (let i = 0; i < this.state.totalMonths; i++) {
            let StartDateOfMonth = temp;
            let monthHead = addDays(StartDateOfMonth, i === 0 ? 0 : 1);
            let endDateOfMonth = endOfMonth(monthHead);
            let dayDifference = differenceInCalendarDays(endDateOfMonth, monthHead);
            let days = [];
            let month = getMonth(monthHead);
            let year = getYear(monthHead);
            let startOfMonthDay = isMonday(monthHead)
            ? 0
            : isTuesday(monthHead)
            ? 1
            : isWednesday(monthHead)
            ? 2
            : isThursday(monthHead)
            ? 3
            : isFriday(monthHead)
            ? 4
            : isSaturday(monthHead)
            ? 5
            : 6;
            let startDateLimit = this.props.startDateLimit;
            let isHoliday = this.props.isHoliday ? this.props.isHoliday : false;
            let holidayStartDate = this.props.holidayStartDate ? this.props.holidayStartDate : '';
            let holidayEndDate = this.props.holidayEndDate ? this.props.holidayEndDate : '';
            let startDate = this.props.startDate;
            let endDate = this.state.endDate;
            let hoverDate = this.state.hoverEndDate;

            for (let k = 0; k < startOfMonthDay; k++) {
                days.push({ day: "", month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
            }
            for (let j = 0; j <= dayDifference; j++) {
                let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(startDateLimit, 'y'), this.specDateEle(startDateLimit, 'm'), this.specDateEle(startDateLimit, 'd')));
                // Only disable dates before today unless user is actively selecting a new check-in (numberOfClicks === 1)
                let isBeforeCheckIn = false;
                if (this.state.numberOfClicks === 1 && this.props.startDate) {
                    isBeforeCheckIn = isBefore(
                        new Date(year, month, j + 1),
                        new Date(
                            this.specDateEle(this.props.startDate, 'y'),
                            this.specDateEle(this.props.startDate, 'm'),
                            this.specDateEle(this.props.startDate, 'd')
                        )
                    );
                } else {
                    isBeforeCheckIn = isBefore(new Date(year, month, j + 1), startOfToday());
                }
                let disableDate = false;
                if (isHoliday) {
                    let isHLDBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(holidayStartDate, 'y'), this.specDateEle(holidayStartDate, 'm'), this.specDateEle(holidayStartDate, 'd')));
                    let isHLDAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(holidayEndDate, 'y'), this.specDateEle(holidayEndDate, 'm'), this.specDateEle(holidayEndDate, 'd')));
                    disableDate = isHLDBeforeDate || isHLDAfterDate;
                }

                let isAfterThirtyNights = isAfter(
                    new Date(year, month, j + 1),
                    addDays(new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")), 30)
                );

                if (isBeforeDate || disableDate || isBeforeCheckIn || (isAfterThirtyNights && this.state.numberOfClicks !== 0)) {
                    days.push({ day: j + 1, month: month, year: year, isDisable: true, selectedDate: false, highlight: false });
                } else {
                    let isStartDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, "y"), this.specDateEle(startDate, "m"), this.specDateEle(startDate, "d")));
                    let isEndDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, "y"), this.specDateEle(endDate, "m"), this.specDateEle(endDate, "d")));
                    let isHoverDate = isSameDay(new Date(year, month, j + 1), new Date(this.specDateEle(hoverDate, "y"), this.specDateEle(hoverDate, "m"), this.specDateEle(hoverDate, "d")));
                    days.push({ day: j + 1, month: month, year: year, isDisable: false, selectedDate: isStartDate || isEndDate, highlight: isHoverDate });
                }

                if (this.state.isDoubleSelection === true) {
                    let isBeforeDate = isBefore(new Date(year, month, j + 1), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                    let isAfterDate = isAfter(new Date(year, month, j + 1), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));

                    if (isAfterDate && isBeforeDate) {
                        days[j].highlight = true;
                    }
                }
            }

            if (this.state.isDoubleSelection === true) {
                let startDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')).toString());
                let endDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')).toString());
                if (startDateIndex !== -1) {
                    days[startDateIndex].selectedDate = true;
                }
                if (endDateIndex !== -1) {
                    days[endDateIndex].selectedDate = true;
                }
            } else {
                let SelectedDate = this.props.value;
                let selectedDateIndex = days.findIndex((items) => new Date(items.year, items.month, items.day).toString() === new Date(this.specDateEle(SelectedDate, 'y'), this.specDateEle(SelectedDate, 'm'), this.specDateEle(SelectedDate, 'd')).toString())
                if (selectedDateIndex !== -1) {
                    days[selectedDateIndex].selectedDate = true;
                }
            }
            temp = endDateOfMonth;
            twoCalendarsArray.push(
                <>
                  
                <div className={this.props.styles.calendar_whole_body} key={i}>
                 
                    <div className={this.props.styles.calendar_head}>
                        <div className={this.props.styles.calendar_head_center_side}>
                            <h3>{format(monthHead, 'MMMM yyyy')}</h3>
                        </div>
                    </div>
                    <div className={`${this.props.styles.calendar_body} ${this.props.styles.calendar_body_wrap}`}>
                      
                        <div className={this.props.styles.calendar_day_list}>
                            {days.map((ele, idx) => {
                                let isHighLight = false;
                                let isHoverDate = false;
                                if (this.state.isDoubleSelection === true) {
                                    let isBeforeDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    let isBeforeEndDate = isBefore(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(endDate, 'y'), this.specDateEle(endDate, 'm'), this.specDateEle(endDate, 'd')));
                                    let isAfterDate = isAfter(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(startDate, 'y'), this.specDateEle(startDate, 'm'), this.specDateEle(startDate, 'd')));
                                    isHoverDate = isSameDay(new Date(ele.year, ele.month, ele.day), new Date(this.specDateEle(hoverDate, 'y'), this.specDateEle(hoverDate, 'm'), this.specDateEle(hoverDate, 'd')));
                                    if ((isAfterDate && isBeforeDate && commonFunction.isValueEmpty(endDate)) || (isAfterDate && isBeforeEndDate && (!commonFunction.isValueEmpty(endDate)))) {
                                        isHighLight = true;
                                    }
                                }
                                return (
                                    <div className={(ele.selectedDate === true && ele.day) ? this.props.styles.day_cell_center + ' ' + this.props.styles.selected_calendar_date : isHighLight === true && ele.day !== "" ? this.props.styles.day_cell_center_highlight : this.props.styles.day_cell_center} key={i + '_' + idx}
                                        onClick={(e) => { e.stopPropagation(); this.debouncedOnClickDateCell(ele.day, ele.month, ele.year, ele.isDisable) }} onMouseEnter={(e) => this.onHoverDayCell(ele, e)} >
                                        {this.state.isDoubleSelection === true && !commonFunction.isValueEmpty(ele.day) && ele.isDisable === false && !commonFunction.isValueEmpty(hoverDate) && isHoverDate && !commonFunction.isValueEmpty(this.state.totalDays) && <div className={this.props.styles.container_tooltip}>{this.state.totalDays} {this.state.totalDays > 1 ? 'Nights' : 'Night'}</div>}
                                        <span className={ele.isDisable === true ? this.props.styles.calendar_day_disable : ''}>{ele.day}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                </>
            )
        }
        return twoCalendarsArray;
    }

    onClickDoneBtn = () => {
        this.props.changeVisibility(false);
    }

    onClickClearDate = () => {
        this.props?.changeVisibility(false);
        this.props?.onClearDate();
      };

    onHoverDayCell = (currentDate, e) => {
        let date = moment(new Date(currentDate.year, currentDate.month, currentDate.day)).format(this.props.dateFormat ? this.props.dateFormat : "DD/MMM/yyyy");
        this.setState({
            hoverEndDate: date
        });
        if (!commonFunction.isValueEmpty(this.props.startDate)) {
            this.setState({
                hoverEndDate: date, pageX: Number(e.clientX) - Number(this.state.initPageX), pageY: Number(e.clientY) - Number(this.state.initPageY)
            }, () => {
                let difference = differenceInCalendarDays(new Date(currentDate.year, currentDate.month, currentDate.day), new Date(this.props.startDate));
                if (difference > 0) this.setState({ totalDays: difference });
                else this.setState({ totalDays: '' });
            })
        }
    }

    selectDateLabelType() {
        let dateLabel = { calaHeadTitle1: "DEPARTURE DATE", calaHeadTitle2: "RETURN DATE" };
        if (this.state.serviceType === "hotel") {
            dateLabel.calaHeadTitle1 = "Check In";
            dateLabel.calaHeadTitle2 = "Check Out";
        } else if (this.state.serviceType === "holiday") {
            dateLabel.calaHeadTitle1 = "START DATE";
            dateLabel.calaHeadTitle2 = "END DATE";
        }
        return dateLabel;
    }

    render() {
        const checkInDt = this.props.value ? `${this.props.value.split("-")[0]}  ${this.props.value.split("-")[1] }`: "";
        const checkOutDt = this.props.value ? `${this.props.value.split("-")[3]}  ${this.props.value.split("-")[4] }`: "";
        const totalNights = this.state.totalNights
        ? `${this.state.totalNights} ${this.state.totalNights > 1 ? 'Nights' : 'Night'}`
        : (() => {
        if (this.props.startDate && this.props.endDate) {
            const nights = differenceInCalendarDays(
            new Date(this.props.endDate),
            new Date(this.props.startDate)
        );
        return nights > 0 ? `${nights} ${nights > 1 ? 'Nights' : 'Night'}` : '';
      }
      return '';
    })();
        const checkInOutdt = `${checkInDt} - ${checkOutDt} `;
        
        return (
            <div onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} className={this.props.styles.calendar_wid_container}>
               
                <div className={this.props.styles.calendar_wid_main}>
                    {!commonFunction.isValueEmpty(this.props.iconImage) ? (
                        <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M5.14454 0.692308C5.14454 0.508696 5.07286 0.332605 4.94526 0.202772C4.81767 0.0729394 4.64461 0 4.46417 0C4.28372 0 4.11066 0.0729394 3.98307 0.202772C3.85547 0.332605 3.78379 0.508696 3.78379 0.692308V2.15077C2.47747 2.25692 1.62111 2.51723 0.991533 3.15877C0.361052 3.79938 0.105231 4.67169 0 6H18C17.8948 4.67077 17.6389 3.79938 17.0085 3.15877C16.3789 2.51723 15.5216 2.25692 14.2162 2.14985V0.692308C14.2162 0.508696 14.1445 0.332605 14.0169 0.202772C13.8893 0.0729394 13.7163 0 13.5358 0C13.3554 0 13.1823 0.0729394 13.0547 0.202772C12.9271 0.332605 12.8555 0.508696 12.8555 0.692308V2.08892C12.2522 2.07692 11.5754 2.07692 10.8143 2.07692H7.18567C6.42455 2.07692 5.74781 2.07692 5.14454 2.08892V0.692308Z" fill="#666666"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M0 9.02041C0 8.26702 1.00583e-08 7.59714 0.0117 7H17.9883C18 7.59714 18 8.26702 18 9.02041V10.8163C18 14.2025 18 15.8961 16.9452 16.9476C15.8904 17.9991 14.1939 18 10.8 18H7.2C3.8061 18 2.1087 18 1.0548 16.9476C0.000899935 15.8952 0 14.2025 0 10.8163V9.02041ZM13.5 10.8163C13.7387 10.8163 13.9676 10.7217 14.1364 10.5533C14.3052 10.3849 14.4 10.1565 14.4 9.91837C14.4 9.68021 14.3052 9.45181 14.1364 9.28341C13.9676 9.11501 13.7387 9.02041 13.5 9.02041C13.2613 9.02041 13.0324 9.11501 12.8636 9.28341C12.6948 9.45181 12.6 9.68021 12.6 9.91837C12.6 10.1565 12.6948 10.3849 12.8636 10.5533C13.0324 10.7217 13.2613 10.8163 13.5 10.8163ZM13.5 14.4082C13.7387 14.4082 13.9676 14.3136 14.1364 14.1452C14.3052 13.9768 14.4 13.7484 14.4 13.5102C14.4 13.2721 14.3052 13.0437 14.1364 12.8753C13.9676 12.7069 13.7387 12.6122 13.5 12.6122C13.2613 12.6122 13.0324 12.7069 12.8636 12.8753C12.6948 13.0437 12.6 13.2721 12.6 13.5102C12.6 13.7484 12.6948 13.9768 12.8636 14.1452C13.0324 14.3136 13.2613 14.4082 13.5 14.4082ZM9.9 9.91837C9.9 10.1565 9.80518 10.3849 9.6364 10.5533C9.46761 10.7217 9.23869 10.8163 9 10.8163C8.7613 10.8163 8.53239 10.7217 8.3636 10.5533C8.19482 10.3849 8.1 10.1565 8.1 9.91837C8.1 9.68021 8.19482 9.45181 8.3636 9.28341C8.53239 9.11501 8.7613 9.02041 9 9.02041C9.23869 9.02041 9.46761 9.11501 9.6364 9.28341C9.80518 9.45181 9.9 9.68021 9.9 9.91837ZM9.9 13.5102C9.9 13.7484 9.80518 13.9768 9.6364 14.1452C9.46761 14.3136 9.23869 14.4082 9 14.4082C8.7613 14.4082 8.53239 14.3136 8.3636 14.1452C8.19482 13.9768 8.1 13.7484 8.1 13.5102C8.1 13.2721 8.19482 13.0437 8.3636 12.8753C8.53239 12.7069 8.7613 12.6122 9 12.6122C9.23869 12.6122 9.46761 12.7069 9.6364 12.8753C9.80518 13.0437 9.9 13.2721 9.9 13.5102ZM4.5 10.8163C4.73869 10.8163 4.96761 10.7217 5.1364 10.5533C5.30518 10.3849 5.4 10.1565 5.4 9.91837C5.4 9.68021 5.30518 9.45181 5.1364 9.28341C4.96761 9.11501 4.73869 9.02041 4.5 9.02041C4.2613 9.02041 4.03239 9.11501 3.8636 9.28341C3.69482 9.45181 3.6 9.68021 3.6 9.91837C3.6 10.1565 3.69482 10.3849 3.8636 10.5533C4.03239 10.7217 4.2613 10.8163 4.5 10.8163ZM4.5 14.4082C4.73869 14.4082 4.96761 14.3136 5.1364 14.1452C5.30518 13.9768 5.4 13.7484 5.4 13.5102C5.4 13.2721 5.30518 13.0437 5.1364 12.8753C4.96761 12.7069 4.73869 12.6122 4.5 12.6122C4.2613 12.6122 4.03239 12.7069 3.8636 12.8753C3.69482 13.0437 3.6 13.2721 3.6 13.5102C3.6 13.7484 3.69482 13.9768 3.8636 14.1452C4.03239 14.3136 4.2613 14.4082 4.5 14.4082Z" fill="#666666"></path></svg>
                        </>
                    ) : null}
                    {this.state.isDoubleSelection === true ? (
                        <>
                        <div className={this.props.styles?.calendar_input_container}
                          onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }} >
                        <input type='text' autoComplete={'off'} id="myTextField" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? checkInOutdt : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                         <span className={this.props.styles.calendar_per_night}>{totalNights}</span>
                        </div>

                </>
                    ) : (
                        <>
                  <input type='text' autoComplete={'off'} id="myTextField" className="search_widget_input_new" readOnly
                            placeholder={!commonFunction.isValueEmpty(this.props.placholder) ? this.props.placholder : ""}
                            value={!commonFunction.isValueEmpty(this.props.value) ? this.props.value : ""}
                            onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}
                        />
                        </>
                    )}
                </div>
                {this.props.isVisible === true ? (
                    <div className={this.props.styles.calendar_wid_container_popup}>
                        <div className={this.props.styles.calendar_modal_close} onClick={(e) => { e.stopPropagation(); this.onClickChangeVisibility() }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
                        <path d="M13.3755 0.652573L7.5 6.52812L1.62445 0.652573C1.42102 0.449142 1.09168 0.449142 0.888772 0.652573L0.152573 1.38877C-0.0508576 1.5922 -0.0508576 1.92154 0.152573 2.12445L6.02812 8L0.152573 13.8755C-0.0508576 14.079 -0.0508576 14.4083 0.152573 14.6112L0.888772 15.3474C1.0922 15.5509 1.42154 15.5509 1.62445 15.3474L7.5 9.47188L13.3755 15.3474C13.579 15.5509 13.9083 15.5509 14.1112 15.3474L14.8474 14.6112C15.0509 14.4078 15.0509 14.0785 14.8474 13.8755L8.97188 8L14.8474 2.12445C15.0509 1.92102 15.0509 1.59168 14.8474 1.38877L14.1112 0.652573C13.9078 0.449142 13.5785 0.449142 13.3755 0.652573Z" fill="#666666"/>
                        </svg>
                        </div>
                        
                        <div className={this.props.styles.calendar_main_body_popup}>
                            <div className={this.props.styles.calendar_week_heads}>
                        
                                <div className={this.props.styles.coln_center_week}>
                                    Sun
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Mon
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Tue
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Wed
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Thu
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Fri
                                </div>
                                <div className={this.props.styles.coln_center_week}>
                                    Sat
                                </div>
                            </div>
                            {this.renderCalendar()}

                            <div className={this.props.styles?.holiday_footer}>
                                <div className={this.props.styles?.holiday_date}>
                                {checkInOutdt} | {totalNights} 
                                </div>
                                <div
                                className={this.props.styles?.holiday_clear}
                                tabIndex="0"
                                role="button"
                                onClick={(e) => {
                                    this.onClickClearDate()
                                }}
                                >
                                Clear
                                </div>
                            </div>
                        </div>
                        <div className={this.props.styles.calendar_footer}>
                            <button onClick={(e) => { e.stopPropagation(); this.onClickDoneBtn() }}>Apply</button>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }
}

export default MobileCalendar;
